module.exports = __webpack_public_path__ + "img/attach_file.cdca7cb4.svg";